import React from "react";
import { Table, Column, Cell } from "fixed-data-table-2";
import PropTypes from "prop-types";

import {
  Button,
  Dialog,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  DialogTitle,
  LinearProgress,
  DialogActions,
  DialogContent,
  DialogContentText,
  // Avatar,
  Checkbox
} from "@material-ui/core";

import { Row, Col } from "react-flexbox-grid";
import AutoSizer from "react-virtualized/dist/commonjs/AutoSizer";

const DetailsModal = props => {
  const formHasIssues =
    props.modalData.count_error || props.modalData.count_warning;
  const warningColor = "rgb(255, 171, 0)";
  const errorColor = "rgb(182, 12, 15)";

  // removeDate is quick workaround to remove dates that sometimes show up in sampleID
  const removeDate = string =>
    string ? string.replace(/\d{4}-\d{2}-\d{2}/, "").trim() : null;
  const rows = props.modalDataDetails;

  const styles = {
    tableFont: {
      fontFamily: "Roboto"
    }
  };

  let tableDiv = <div />;
  if (formHasIssues) {
    tableDiv = (
      <div style={styles.tableFont}>
        <div>Check a row to change its status.</div>
        <AutoSizer disableHeight>
          {({ width }) => (
            <Table
              rowHeight={60}
              rowsCount={rows.length}
              style={{ marginLeft: 20 }}
              width={width}
              // height={60 * (rows.length + 1)}
              maxHeight={window.innerHeight * 0.3}
              headerHeight={50}
              onRowDoubleClick={(e, i) => props.onModalDetailsClick(i)}
            >
              <Column
                columnKey="checkbox"
                header={
                  <Checkbox
                    checked={props.processLogToggleSelectAll}
                    onChange={e =>
                      props.onProcessLogSelectAllCheck(
                        rows.length,
                        e.target.checked
                      )
                    }
                  />
                }
                cell={({ rowIndex }) => (
                  <Checkbox
                    style={{ marginTop: "6px" }}
                    onChange={e =>
                      props.onProcessLogRowCheck(rowIndex, e.target.checked)
                    }
                    checked={
                      props.processLogIndexCheckedArray.includes(rowIndex) ||
                      props.processLogToggleSelectAll
                    }
                  />
                )}
                width={50}
                fixed
              />
              <Column
                columnKey="hint"
                header={
                  <Cell>
                    <span style={{ color: errorColor }}>
                      Errors ({props.modalData.count_error || 0})
                    </span>
                    {" / "}

                    <span style={{ color: warningColor }}>
                      Warnings ({props.modalData.count_warning || 0})
                    </span>
                  </Cell>
                }
                cell={({ rowIndex, ...colProps }) => (
                  <Cell
                    {...colProps}
                    style={{
                      margin: 5,
                      backgroundColor:
                        rows[rowIndex].level === "WARNING"
                          ? warningColor
                          : errorColor
                    }}
                  >
                    {/* <Avatar
                      size={30}
                      style={{
                        margin: 5,
                        backgroundColor:
                          rows[rowIndex].level === "WARNING"
                            ? warningColor
                            : errorColor
                      }}
                    >
                      {" "}
                      &nbsp;
                    </Avatar> */}
                    {rows[rowIndex].hint}
                  </Cell>
                )}
                width={100}
                flexGrow={2}
              />

              <Column
                columnKey="table"
                header={<Cell>Table</Cell>}
                cell={({ rowIndex, ...colProps }) => (
                  <Cell {...colProps}>{rows[rowIndex].table}</Cell>
                )}
                flexGrow={2}
                width={100}
              />
              <Column
                columnKey="sample_id"
                header={<Cell>Sample ID</Cell>}
                cell={({ rowIndex, ...colProps }) => (
                  <Cell {...colProps}>
                    {removeDate(rows[rowIndex].sample_id) ? (
                      <Button
                        variant="contained"
                        onClick={() =>
                          props.onFindSampleInFormDataClick(
                            removeDate(rows[rowIndex].sample_id)
                          )
                        }
                      >
                        {removeDate(rows[rowIndex].sample_id)}
                      </Button>
                    ) : null}
                  </Cell>
                )}
                flexGrow={2}
                width={100}
              />
              <Column
                columnKey="status"
                header={<Cell>Status</Cell>}
                cell={({ rowIndex, ...colProps }) => (
                  <Cell {...colProps}>{rows[rowIndex].status}</Cell>
                )}
                flexGrow={2}
                width={100}
              />
              <Column
                columnKey="moredetails"
                header={<Cell />}
                cell={({ rowIndex }) => (
                  <Cell>
                    <Button
                      variant="contained"
                      onClick={() => props.onModalDetailsClick(rowIndex)}
                    >
                      Details
                    </Button>
                  </Cell>
                )}
                width={120}
              />
            </Table>
          )}
        </AutoSizer>
      </div>
    );
  } else {
    tableDiv = (
      <DialogContentText>
        <b>Submission has no errors/warnings.</b>
      </DialogContentText>
    );
  }

  return (
    <Dialog
      fullWidth
      maxWidth={false}
      modal="true"
      open={props.detailsModalOpen}
      onClose={props.onDetailsModalClose}
      scroll="body"
    >
      <DialogTitle>
        <Row>
          <Col xs={12}>{props.modalData.form_name}</Col>
        </Row>
      </DialogTitle>
      <DialogContent>
        <Row style={{ fontSize: 16 }}>
          <Col xs={12}>
            {props.modalDataDetails.length ? (
              <Row style={{ textAlign: "left" }}>
                <Col xs={8}>
                  <FormControl fullWidth>
                    <InputLabel fullWidth>
                      {props.processLogIndexCheckedArray.length
                        ? `Change Status of ${props.processLogIndexCheckedArray.length} checked row(s):`
                        : "Check a row to change its status."}
                    </InputLabel>
                    <Select
                      disabled={!props.processLogIndexCheckedArray.length}
                      value={props.processLogNewStatus}
                      onChange={e => props.onBulkStatusChange(e.target.value)}
                    >
                      <MenuItem value="Resolved">Resolved</MenuItem>
                      <MenuItem value="Unknown">Unknown</MenuItem>
                      <MenuItem value="Assigned">Assigned</MenuItem>
                      <MenuItem value="Disregard">Disregard</MenuItem>
                      <MenuItem value="Not Resolvable">Not Resolvable</MenuItem>
                    </Select>
                  </FormControl>
                </Col>
                <Col xs={3}>
                  <Button
                    variant="text"
                    style={{ marginTop: 30 }}
                    onClick={props.onBulkStatusClick}
                    disabled={
                      props.processLogIndexCheckedArray.length === 0 ||
                      !props.processLogNewStatus
                    }
                    color="primary"
                  >
                    Update
                  </Button>
                </Col>
              </Row>
            ) : null}
          </Col>
        </Row>
        <div style={{ padding: 20 }}>
          <Row>
            <Col xs={12}>
              {props.isFetchingModalDetails ? <LinearProgress /> : tableDiv}
            </Col>
          </Row>
        </div>

        {!props.modalData.process_form && (
          <DialogContentText>
            <b>This submission has been flagged for deletion.</b>
          </DialogContentText>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          variant="text"
          color="primary"
          onClick={props.onDetailsModalClose}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

DetailsModal.defaultProps = {
  processLogNewStatus: "",
  processLogToggleSelectAll: false,
  detailsModalOpen: false,
  isFetchingModalDetails: false,
  processLogIndexCheckedArray: []
};

DetailsModal.propTypes = {
  onFindSampleInFormDataClick: PropTypes.func.isRequired,
  onDeleteFormButtonClick: PropTypes.func.isRequired,
  onRecallButtonClick: PropTypes.func.isRequired,
  onMakeTemplateButtonClick: PropTypes.func.isRequired,
  onChangeOrderOpen: PropTypes.func.isRequired,
  onFormJSONClick: PropTypes.func.isRequired,
  onModalDetailsClick: PropTypes.func.isRequired,
  processLogNewStatus: PropTypes.string,
  onBulkStatusClick: PropTypes.func.isRequired,
  processLogToggleSelectAll: PropTypes.bool,
  onProcessLogSelectAllCheck: PropTypes.func.isRequired,
  onBulkStatusChange: PropTypes.func.isRequired,
  onProcessLogRowCheck: PropTypes.func.isRequired,
  isFetchingModalDetails: PropTypes.bool,
  detailsModalOpen: PropTypes.bool,
  onDetailsModalClose: PropTypes.func.isRequired,
  processLogIndexCheckedArray: PropTypes.arrayOf(PropTypes.number),
  modalDataDetails: PropTypes.arrayOf(
    PropTypes.shape({
      detail: PropTypes.string,
      hint: PropTypes.string,
      level: PropTypes.string,
      message: PropTypes.string,
      pk: PropTypes.number,
      report: PropTypes.shape({
        action: PropTypes.string,
        class: PropTypes.string,
        hakai_sample_id: PropTypes.string,
        level: PropTypes.string,
        new_row: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
        old_row: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
        table_name: PropTypes.string
      }),
      sample_id: PropTypes.string,
      status: PropTypes.string,
      status_log: PropTypes.string,
      submission_id: PropTypes.string,
      submission_user_email: PropTypes.string,
      table: PropTypes.string
    })
  ).isRequired,
  modalData: PropTypes.shape({
    warning_log: PropTypes.string,
    form_name: PropTypes.string,
    submission_device: PropTypes.string,
    count_warning: PropTypes.string,
    error_log: PropTypes.string,
    submission_source: PropTypes.string,
    submission_id: PropTypes.string,
    process_form: PropTypes.bool,
    submitted_dt: PropTypes.string,
    count_error: PropTypes.string
  }).isRequired
};

export default DetailsModal;
